/** @jsx jsx */

import { Spacing } from '@zapier/theme';
import { Button, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    align-items: center;
    display: flex;
    gap: ${Spacing.small}px;
    width: 100%;
  `,
};

type Props = {
  onClick: () => Promise<void>;
};

const RefreshLogs = ({ onClick }: Props) => {
  return (
    <div css={Styles.root}>
      <Button color="secondary" iconBefore="arrowRefresh" onClick={onClick}>
        Refresh logs
      </Button>
      <Text tag="p">Having trouble connecting?</Text>
    </div>
  );
};

export default RefreshLogs;
